<template>
    <div class="list_nav_wrap toggle-nav">
        <h1 class="list_nav_title">
            <label>{{ keyName }}</label>
        </h1>
        <div class="sc-option" data-ui="dropdown" id="brand_option" style="z-index: 994;">
            <div class="sc-option-hd"
                @click="show = true">
                <div class="sc-option-content">
                    {{ activeName }}
                </div>
                <div class="sc-option-action">
                    <i></i>
                </div>
            </div>
            <ul v-if="show"
                class="sc-option-list" style="top: 25px;">
                <li v-for="item in list">
                    <a @click="doSelect(item.value)"
                    :id-data="item.value">
                        {{ item.name }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    let formBean = window._qiwa.page_global.formBean;
    export default {
        data() {
            return {
                key: 'carMileage',
                keyName: '里程',
                show: false,
                activeName: formBean.mileageName || '请选择里程数',
                list: [{
                    value: '0-10000',
                    name: '1万公里以内'
                }, {
                    value: '0-30000',
                    name: '3万公里以内'
                }, {
                    value: '0-50000',
                    name: '5万公里以内'
                }, {
                    value: '0-80000',
                    name: '8万公里以内'
                }, {
                    value: false,
                    name: '不限'
                }]
            };
        },
        methods: {
            doSelect(value) {
                if (value) {
                    locationObj.s(this.key, value).s('index', null).go();
                } else {
                    locationObj.s(this.key, null).s('index', null).go();
                }
            }
        },
        mounted() {
            let $ = window.$;
            $('body').click((event) => {
                if (!$(event.target).closest('.sc-option').length) {
                    this.show = false;
                }
            });
        }
    };
</script>

<style lang="less" scoped>
    a {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// NavDis.vue?c57e8578